import type { LearningFeatureGrammarV2, LearningFeatureTranslationV2, LearningFeatureV2 } from '@app/data'

export class LearningFeatureUtils {
  static isTranslationLearningFeature(
    learningFeature: LearningFeatureV2
  ): learningFeature is LearningFeatureTranslationV2 {
    return (learningFeature as LearningFeatureTranslationV2).__typename === 'LearningFeatureTranslationV2'
  }

  static isGrammarLearningFeature(learningFeature: LearningFeatureV2): learningFeature is LearningFeatureGrammarV2 {
    return (learningFeature as LearningFeatureGrammarV2).__typename === 'LearningFeatureGrammarV2'
  }

  static getTranslationLearningFeature(learningFeature: LearningFeatureV2): LearningFeatureTranslationV2 | null {
    if (this.isTranslationLearningFeature(learningFeature)) {
      return learningFeature
    }
    return null
  }

  static getGrammarLearningFeature<T = LearningFeatureGrammarV2>(
    learningFeature: T
  ): Partial<LearningFeatureGrammarV2> | null {
    if (this.isGrammarLearningFeature(learningFeature as LearningFeatureV2)) {
      return learningFeature as LearningFeatureGrammarV2
    }
    return null
  }
}
